import { chain, map } from 'fp-ts/lib/TaskEither';
import { flow, pipe } from 'fp-ts/lib/function';
import { detailCodec, listCodec } from './codec';
import {
  createAuthorizedGetRequest,
  createAuthorizedPutRequest,
  createAuthorizedPostRequest,
  decode,
  decodeVersioned,
  fetchApi,
  setQuery,
  setBody,
} from '../..';
import { encodeNotificationQuery, NotificationQuery } from './query';

const baseUrl = '/v2/notifications';
const recordUrl = (id: string): string => `${baseUrl}/${id}`;

export const list = (query: NotificationQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery(encodeNotificationQuery(query))),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(detailCodec)),
);

export const markAsRead = (id: string) => pipe(
  id,
  recordUrl,
  createAuthorizedPutRequest,
  chain(fetchApi),
);

export const markAllAsRead = (records: string[]) => pipe(
  `${baseUrl}/mark-as-read`,
  createAuthorizedPostRequest,
  map(setBody({ records })),
  chain(fetchApi),
);
